import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * @typedef {object} typeplayer
 * @property {boolean} typeplayer.jumping
 * @property {number} typeplayer.jump
 * @property {number} typeplayer.jumpcooldown
 */

/**
 * The player data.
 * @type {typeplayer}
 * @constant
 */
const player = {

    'jumping': true,
    'jump': -1,
    'jumpcooldown': 0
};

/**
 * The state manager of the player data.
 * @type {import('@hypercubejs/hypercubejs').State<typeplayer>}
 * @constant
 */
const stateplayer = new HYPERCUBEJS.State(player);

export {

    stateplayer
};

export default stateplayer;
